import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/faq/FaqAccordion.tsx");
